import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { Dropdown } from "primereact/dropdown";
import { InputMask } from "primereact/inputmask";
import NumericInput from 'components/RH/inputs/InputNumericInput'; // Importe o componente

const InformacoesPessoais = ({
  dados,
  HandleChange,
  HandleDropdownChange,
  Escolaridades,
  obrigatorios = [],
  errors = {}
}) => {
  // Estados locais para controle dos inputs específicos
  const [carteiraTrabalho, setCarteiraTrabalho] = useState(dados.carteiraTrabalho);

  // Sincronizar estado local com estado global
  useEffect(() => {
    setCarteiraTrabalho(dados.carteiraTrabalho);
  }, [dados.carteiraTrabalho]);

  // Handler para atualizar o estado local e propagar mudanças para o estado global se necessário
  const handleChangeCarteiraTrabalho = (value) => {
    setCarteiraTrabalho(value);
    // Atualizar diretamente o estado global
    HandleChange({ 
      target: { 
        name: "carteiraTrabalho", 
        value 
      } 
    });
  };

  const isRequired = (campo) => obrigatorios.includes(campo);
  const isError = (campo) => errors && errors[campo];

  return (
    <div className="row g-3">
      <div className="col-md-6 col-lg-3">
        <label htmlFor="pis" className="form-label">
          PIS{isRequired("pis") && <span className="text-danger">*</span>}
        </label>
        <InputMask
          id="pis"
          name="pis"
          value={dados.pis}
          onChange={HandleChange}
          className={`form-control${isError("pis") ? " is-invalid" : ""}`}
          mask="999.99999.99-9"
        />
        {isError("pis") && <div className="invalid-feedback">Obrigatório</div>}
      </div>
      <div className="col-md-6 col-lg-3">
        <label htmlFor="carteiraTrabalho" className="form-label">
          Carteira de Trabalho{isRequired("carteiraTrabalho") && <span className="text-danger">*</span>}
        </label>
        <NumericInput
          value={carteiraTrabalho}
          onChange={handleChangeCarteiraTrabalho}
          maxLength={11}
          className={isError("carteiraTrabalho") ? "is-invalid" : ""}
        />
        {isError("carteiraTrabalho") && <div className="invalid-feedback">Obrigatório</div>}
      </div>
      <div className="col-md-6 col-lg-3">
        <label htmlFor="tituloEleitor" className="form-label">
          Título de Eleitor{isRequired("tituloEleitor") && <span className="text-danger">*</span>}
        </label>
        <InputMask
          id="tituloEleitor"
          name="tituloEleitor"
          value={dados.tituloEleitor}
          onChange={HandleChange}
          className={`form-control${isError("tituloEleitor") ? " is-invalid" : ""}`}
          mask="9999 9999 9999"
        />
        {isError("tituloEleitor") && <div className="invalid-feedback">Obrigatório</div>}
      </div>
      <div className="col-md-6 col-lg-3">
        <label htmlFor="escolaridadeId" className="form-label">
          Escolaridade{isRequired("escolaridadeId") && <span className="text-danger">*</span>}
        </label>
        <Dropdown
          id="escolaridadeId"
          value={dados.escolaridadeId}
          onChange={(e) => HandleDropdownChange(e, "escolaridadeId")}
          options={Escolaridades}
          placeholder="Selecione o nível de escolaridade"
          // Sempre inclua 'p-dropdown' para garantir o estilo PrimeReact
          className={`p-dropdown w-100${isError("escolaridadeId") ? " is-invalid" : ""}`}
        />
        {isError("escolaridadeId") && <div className="invalid-feedback">Obrigatório</div>}
      </div>
      <div className="col-md-6 col-lg-3">
        <label htmlFor="tamanhoUniforme" className="form-label">
          Tamanho do Uniforme{isRequired("tamanhoUniforme") && <span className="text-danger">*</span>}
        </label>
        <Dropdown
          id="tamanhoUniforme"
          name="tamanhoUniforme"
          value={dados.tamanhoUniforme}
          onChange={HandleChange}
          options={["P", "M", "G", "GG", "EG"]}
          placeholder="Selecione o Tamanho do Uniforme"
          className={`w-100${isError("tamanhoUniforme") ? " is-invalid" : ""}`}
        />
        {isError("tamanhoUniforme") && <div className="invalid-feedback">Obrigatório</div>}
      </div>
    </div>
  );
};

InformacoesPessoais.propTypes = {
  dados: PropTypes.shape({
    pis: PropTypes.string.isRequired,
    carteiraTrabalho: PropTypes.string.isRequired,
    tituloEleitor: PropTypes.string.isRequired,
    escolaridadeId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    tamanhoUniforme: PropTypes.string
  }).isRequired,
  HandleChange: PropTypes.func.isRequired,
  HandleDropdownChange: PropTypes.func.isRequired,
  Escolaridades: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired
    })
  ).isRequired,
  obrigatorios: PropTypes.arrayOf(PropTypes.string),
  errors: PropTypes.objectOf(PropTypes.bool)
};

InformacoesPessoais.defaultProps = {
  obrigatorios: [],
  errors: {}
};

export default InformacoesPessoais;
